function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import last from 'lodash/last';
import range from 'lodash/range';
import { ANIMATION_MAP, DIRECTION_LEFT, DIRECTION_RIGHT, TOUCH_DISTANCE_DIVIDER } from '../constants'; // To allow for infinite scroll, reset to last index if there are no more previous items unless it should not cycle

export var getPreviousIndex = function getPreviousIndex(totalItems, shouldCycle, _ref) {
  var prevDisplayIndex = _ref.displayIndex;
  var cycledDisplayIndex = shouldCycle ? totalItems - 1 : 0;
  return {
    displayIndex: prevDisplayIndex === 0 ? cycledDisplayIndex : prevDisplayIndex - 1
  };
}; // To allow for infinite scroll, reset to 0 index if there are no more next items unless it should not cycle

export var getNextIndex = function getNextIndex(totalItems, shouldCycle, _ref2) {
  var prevDisplayIndex = _ref2.displayIndex;
  var cycledDisplayIndex = shouldCycle ? 0 : prevDisplayIndex;
  return {
    displayIndex: prevDisplayIndex === totalItems - 1 ? cycledDisplayIndex : prevDisplayIndex + 1
  };
};
export var getTouchDistance = function getTouchDistance(_ref3) {
  var clientX = _ref3.clientX,
      screenX = _ref3.screenX,
      touchPosition = _ref3.touchPosition;
  var distance = clientX - touchPosition; // Limit client from sliding the current item out of view

  var normalizedDistance = Math.min(Math.abs(clientX - touchPosition), screenX / TOUCH_DISTANCE_DIVIDER); // Restore distance to a signed number so we can later determine the direction of the swipe

  return distance > 0 ? normalizedDistance : -normalizedDistance;
};
/**
 * Given a list of children, splits it into what should be in the
 * previous, current, or next categories based on current display index and items per slide
 */

export var getSlideItems = function getSlideItems(children, displayIndex, itemsPerSlide) {
  var shouldCycle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var indexes = range(itemsPerSlide).reduce(function (memo, next, index) {
    var indexToShow = displayIndex + index;

    if (!children[indexToShow]) {
      var lastIndex = last(memo);
      indexToShow = getNextIndex(children.length, shouldCycle, {
        displayIndex: lastIndex
      }).displayIndex;
    }

    return [].concat(_toConsumableArray(memo), [indexToShow]);
  }, []);
  return {
    onScreen: indexes.map(function (index) {
      return children[index];
    }),
    offScreen: children.filter(function (child, i) {
      return indexes.indexOf(i) === -1;
    })
  };
};
export var getTransition = function getTransition(_ref4) {
  var prevTransition = _ref4.prevTransition,
      prevDisplayIndex = _ref4.prevDisplayIndex,
      displayIndex = _ref4.displayIndex,
      totalItems = _ref4.totalItems;
  var transition = prevTransition; // The next index is greater than previous, so move previous items to the left

  if (prevDisplayIndex < displayIndex) {
    transition = ANIMATION_MAP[DIRECTION_LEFT];
  } // The next index is less than previous, so move previous items to the right


  if (prevDisplayIndex > displayIndex) {
    transition = ANIMATION_MAP[DIRECTION_RIGHT];
  } // Override direction in case we're moving from last index to zero (infinite scroll)


  if (prevDisplayIndex === totalItems - 1 && displayIndex === 0) {
    transition = ANIMATION_MAP[DIRECTION_LEFT];
  } // Override direction in case we're moving from zero to last index (infinite scroll)


  if (prevDisplayIndex === 0 && displayIndex === totalItems - 1) {
    // The next index is less than previous, or moving from zero to last index (infinite scroll)
    // In this case, we want to show previous item, and move previous items to the right
    transition = ANIMATION_MAP[DIRECTION_RIGHT];
  }

  return transition;
};